import EmailSignInBlock, { EmailSignInBlockProps } from './EmailSignInBlock';
import withInteractor from './EmailSignIn.interactor';
import withPresenter from './EmailSignIn.presenter';

export type { EmailSignInBlockProps };
export default withInteractor(withPresenter(EmailSignInBlock));
